import request from '@/service/request'

export const getHomeConfig = (params: any) => {
  return request<SERVICE.Response<HOME.HOMECONFIG[]>>({
    url: '/admin/home-config',
    method: 'GET',
    params
  })
}

export const addHomeConfig = (data: HOME.HOMECONFIG) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/home-config',
    method: 'POST',
    data
  })
}

export const delHomeConfig = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/home-config/${id}`,
    method: 'DELETE'
  })
}

export const getCustomerConfig = (params: any) => {
  return request<SERVICE.ResponsePage<HOME.CUSTOMER_CONFIG[]>>({
    url: '/admin/mpCustomerConfig',
    method: 'GET',
    params
  })
}

export const addCustomeConfig = (data: HOME.CUSTOMER_CONFIG) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/mpCustomerConfig',
    method: 'POST',
    data
  })
}

export const delCustomeConfig = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/mpCustomerConfig/${id}`,
    method: 'DELETE'
  })
}
